import React, { useState, useEffect } from 'react';
import Search from '../components/Search/Search';
import '../components/Search/Search.scss'

const SearchPage = () => {

    const [searchData, setSearchData] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [searchValue, setSearchValue] = useState('');

    const getSearchRequest = async (searchValue) => {
        let movieTitle = searchValue
        const url = `https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&page=1&include_adult=true&query=${movieTitle}`
        const searchResponse = await fetch(url);
        const searchResults = await searchResponse.json();

        if (searchResults.results) {
            setSearchData(searchResults.results);
        }
    }
        
    useEffect(() => {
        getSearchRequest(searchValue);
    }, [searchValue])

    const handleInput  = async (event) => {
        const theInput = event.target.value;
        setSearchInput(theInput)
    }

    const handleSubmit = event => {
        event.preventDefault();
        setSearchValue(searchInput);
    }

    return (
        <div className="search-page">
            <div className="search-box-relative">
                <form action="" className="search-form">
                    <input 
                        className="search-input" 
                        type="text" 
                        placeholder="Search movie titles"
                        onChange={handleInput}
                        onSubmit={handleSubmit}
                    />
                    <button type="submit" className="search-btn" onClick={handleSubmit}>Search</button>
                </form>
            </div>
            <div className="featured-header">
                <div className="featured-header-link">
                    Search Results
                </div>
            </div>
            <Search searchData={searchData}/>            
        </div>
    )
}

export default SearchPage
